import * as components from './components';

export default [
  {
    path: '/masters/customers',
    component: components.CustomerList,
    name: 'customerList',
    meta: { admin: true }
    },
    {
        path: '/masters/customersnotifications',
        component: components.CustomerNotificationList,
        name: 'customerNotificationsList',
        meta: { admin: true }
    }
];


// WEBPACK FOOTER //
// ./ClientApp/app/masters/customers/routes.js